import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import logoImage from '@/assets/images/login/loginTitle.png';
import rjLogoImage from '@/assets/images/login/rj_box_logo.png';
import { setLocalStorage } from '@/utils/localStorage';
import { useLoginChannelLogo } from '../hooks/useLoginChannelLogo';
const LOGIN_HISTORY_KEY = 'goBackUserName';

interface HeadBtnProps {
  headBtnType?: number;
  headBtnUser?: string;
  onGoBackPage?: () => void;
}

function LoginHeadBtn(props: HeadBtnProps) {
  const { headBtnType, headBtnUser, onGoBackPage } = props;
  const history: any = useHistory();
  const logo = useLoginChannelLogo(logoImage, rjLogoImage);
  const onGoBack = () => {
    if (headBtnType && headBtnType === 2) {
      return history.replace('/login/account');
    }
    if (headBtnType && headBtnType === 3 && headBtnUser) setLocalStorage(LOGIN_HISTORY_KEY, headBtnUser);
    if (headBtnType && headBtnType === 4) {
      return onGoBackPage && onGoBackPage();
    }
    history.goBack();
  };

  return (
    <div className="login_header_box">
      <div className="login_header_box-operation_box">
        {headBtnType && headBtnType === 1 ? (
          <div></div>
        ) : (
          <span
            className="operation_back"
            onClick={e => {
              e.stopPropagation();
              onGoBack();
            }}
          ></span>
        )}
      </div>
      <img className="login_header_box-logo_box" src={logo || ''} alt="" />
    </div>
  );
}
export default memo(LoginHeadBtn);
